import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['pagination.component.css']
})
export class PaginationComponent {

    @Input() currentPage: number = 1;
    @Input() pageSize: number;
    @Input() totalItems: number;
    @Input() isLoading: boolean;

    @Output() loadMore = new EventEmitter<number>();

    isPreviousButtonVisible(): boolean {
        return this.currentPage > 1;
    }

    isNextButtonVisible(): boolean {
        if (this.totalItems == 0 || this.pageSize == 0)
            return false;

        return this.currentPage < Math.ceil(this.totalItems / this.pageSize);
    }

    onPreviousClick(): void {
        if (this.isLoading) return;
        this.currentPage--;
        if (this.currentPage <= 0) {
            this.currentPage = 1;
        }
        this.loadMore.emit(this.currentPage);
    }

    onNextClick(): void {
        if (this.isLoading) return;
        this.currentPage++;
        this.loadMore.emit(this.currentPage);
    }
}